/*
Replace
resourceName with your resource Name :) Take care about different writings!
/!\ ResourceName resourceName ResourceNames resourceNames /!\
Keep an eye on pluralized namings in here :)

*/
/**
 *  Sagas for the ResourceNames resource managment using Swagger client
 *
 * Each saga watcher intercepts a trigger action, does the asyncrhonous work in the respective worker saga and dispatches a success or a failure action.
 * Fetch calls are made via the swagger tags interface requests
 *
 */

import { apiClient, applyHeaders, buildHeaders } from "@bkry/bowline-utils";
import { call, put, takeEvery, all, select } from "redux-saga/effects";
import { push } from "connected-react-router";
import { storeIncluded } from "../dictionarySagas";
import { actions as holderActions } from "../holders";
import { actions as formLocalesActions } from "../formLocales";
import { actions } from "./index";

/** Worker Sagas */

/** List Saga
 *  @description: connects to the getResourceName operation
 */
export function* list(action) {
  const locale = yield select((state) => state.i18nState.lang);
  let headers = yield buildHeaders(locale);

  try {
    const SwaggerClient = yield call(apiClient);
    const payload = yield call(
      SwaggerClient.apis.Projects.listProjects,
      {
        ...action.payload,
      },
      {
        requestInterceptor: applyHeaders(headers),
      }
    );

    if (payload.obj?.included)
      yield* storeIncluded({ payload: payload.obj.included });
    yield put(actions.listSuccess(payload));
    yield all(
      payload.obj.data.map((pr) => {
        return put(
          formLocalesActions.setProjectAvailableLocales({
            projectId: pr.id,
            availableLocales: pr.attributes.available_languages,
          })
        );
      })
    );
  } catch (e) {
    yield put(actions.listFail({ message: e.message, ...e }));
  }
}

/** Show Saga
 *  @description: connects to the showResourceName operation
 *  @param {number} action.payload the ResourceName id
 */
export function* show(action) {
  let locale = yield select((state) => state.i18nState.lang);
  let headers = yield buildHeaders(locale);
  const projectId = action.payload;

  if (projectId === "UNKOWN") {
    yield put(actions.showFail({ message: "Project ID can't be UNKOWN" }));
    return;
  }

  try {
    const SwaggerClient = yield call(apiClient);

    const payload = yield call(
      SwaggerClient.apis.Projects.showProject,
      { id: projectId },
      { requestInterceptor: applyHeaders(headers) }
    );
    yield* storeIncluded({ payload: payload.obj.included });
    yield put(actions.showSuccess(payload.obj.data));
    yield put(
      formLocalesActions.setProjectAvailableLocales({
        projectId: projectId,
        availableLocales: payload.obj.data.attributes.available_languages,
      })
    );
  } catch (e) {
    yield put(actions.showFail({ message: e.message, ...e }));
  }
}

export function* create(action) {
  let headers = yield buildHeaders();
  let { title, projectSlug, callbackFnc } = action.payload;
  try {
    const SwaggerClient = yield call(apiClient);
    let payload = yield call(
      SwaggerClient.apis.Projects.createProject,
      {},
      {
        requestInterceptor: applyHeaders(headers),
        requestBody: {
          project: {
            title: title,
            project_slug: projectSlug,
          },
        },
      }
    );

    if (payload.obj.included) {
      yield* storeIncluded({ payload: payload.obj.included });
    }
    yield put(actions.createSuccess(payload.obj.data));

    if (payload?.obj?.data?.id) {
      yield put(
        formLocalesActions.setProjectAvailableLocales({
          projectId: payload.obj.data.id,
          availableLocales: payload.obj.data.attributes.available_languages,
        })
      );
      if (callbackFnc) {
        callbackFnc(payload.obj);
      } else {
        yield put(push(`/projects/${payload.obj.data.id}/`));
      }
    }
  } catch (e) {
    yield put(actions.createFail({ message: e.message, ...e }));
  }
}

export function* update(action) {
  const { projectId, callbackFnc, ...requestBody } = action.payload;
  let headers = yield buildHeaders();
  try {
    const SwaggerClient = yield call(apiClient);
    let payload = yield call(
      SwaggerClient.apis.Projects.updateProject,
      { id: projectId },
      {
        requestInterceptor: applyHeaders(headers),
        requestBody,
      }
    );

    if (payload.obj?.included)
      yield* storeIncluded({ payload: payload.obj.included });

    yield put(actions.updateSuccess(payload.obj.data));
    yield put(
      formLocalesActions.setProjectAvailableLocales({
        projectId: projectId,
        availableLocales: payload.obj.data.attributes.available_languages,
      })
    );
    if (callbackFnc) callbackFnc(payload.obj);
  } catch (e) {
    yield put(actions.updateFail({ message: e.message, ...e }));
  }
}

/** Show Saga
 *  @description: connects to the showResourceName operation
 *  @param {number} action.payload the ResourceName id
 */
export function* dashboard(action) {
  let headers = yield buildHeaders();
  try {
    const SwaggerClient = yield call(apiClient);
    const payload = yield call(
      SwaggerClient.apis.Projects.showDashboardForProject,
      { project_id: action.payload.project_id },
      { requestInterceptor: applyHeaders(headers) }
    );
    yield* storeIncluded({ payload: payload.obj.included });
    yield put(actions.dashboardSuccess(payload.obj.data));

    // store holder wallets in holders redux
    const holderIds = payload?.obj?.data?.relationships?.holders?.data?.map(
      (k) => k.id
    );

    const holderWallets = payload.obj?.included.filter(
      (e) => e.type == "wallet" && holderIds.includes(e.id)
    );
    yield all(
      holderWallets.map((hw) => {
        return put(holderActions.addToDictionary(hw));
      })
    );
  } catch (e) {
    yield put(actions.dashboardFail({ message: e.message, ...e }));
  }
}

/**
 * Saga Watchers
 * The exported list of sagas registered. When one of the action types is dispatched
 * the related worker saga is invoked.
 * Each saga is executed in a different thread
 */
function* projectSaga() {
  yield takeEvery(actions.list, list);
  yield takeEvery(actions.show, show);
  yield takeEvery(actions.dashboard, dashboard);
  yield takeEvery(actions.create, create);
  yield takeEvery(actions.update, update);
}
export default projectSaga;
